import { createContext, useContext, useRef } from "react";

const BreadcrumbsCacheContext = createContext();

export function BreadcrumbsCacheProvider({ children }) {
 const cacheRef = useRef({}); // shared mutable cache
 return (
  <BreadcrumbsCacheContext.Provider value={cacheRef.current}>
   {children}
  </BreadcrumbsCacheContext.Provider>
 );
}

export const useBreadcrumbsCache = () => useContext(BreadcrumbsCacheContext);
